// router/index.ts
import { createRouter, createWebHistory } from 'vue-router'
import staticRoutes from './staticRoutes'
import { authGuard } from './guards/authGuard'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: staticRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  },
})

router.beforeEach(authGuard)

export { router } // ⬅️ named export for injection use
export async function setupRouter() {
  return router
}
